import { EProjectStatusId } from "constants/index";

export const PROJECT_STATUS_COL_ID = "project_status";

export enum EProjectStatus {
  Active = "Active",
  Archived = "Archived"
}

export const getProjectStatus = (project?: {
  project_status_id?: number | null;
}): EProjectStatus | null => {
  switch (project?.project_status_id) {
    case EProjectStatusId.Active:
      return EProjectStatus.Active;
    case EProjectStatusId.Archived:
      return EProjectStatus.Archived;
    default:
      return null;
  }
};
